import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { rSetShowFab } from "../../redux/reducers/GlobalVariables";
import { useLocation, useNavigate } from "react-router-dom";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import ChallanCard from "./ChallanCard";
import ChallanTable from "./ChallanTable";
import Swal from "sweetalert2";

const ChallanPage = () => {
  //#region code
  const { company_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables,
  );
  const open = useSelector((state) => state.sideExpand.open);
  const [tableData, setTableData] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [editData, setEditData] = useState({});
  const dispatch = useDispatch();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    //     fetchSalesOrderList();
    scrollToTop();
  }, []);

  const handlePopup = () => {
    if (isCreate === true) {
      clear();
    }
    dispatch(rSetShowFab(isCreate));
    setIsCreate(!isCreate);
    setIsEdit(false);

  };

  const handleEditData = (data) => {
    dispatch(rSetShowFab(isCreate));
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
    // console.log("object", data);
  };

  const clear = () => {
    setEditData({});
  };

  const location = useLocation();
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    if (location.state?.selectedCustomer) {
      setSelectedCustomer(location.state.selectedCustomer);
    }
    if (location.state?.productData) {
      setProductData(location.state.productData);

      // ✅ Clear location.state after using it (will not persist after refresh)
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const [challanData, setChallanData] = useState(null);
  const [billResponse, setBillResponse] = useState(null);
  const [challanDataCopy, setChallanDataCopy] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.challanData) {
      setChallanData(location.state.challanData);
      setBillResponse(location.state.billResponse);

      // ✅ IMPORTANT: Clear router state after reading once
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state?.challanDataCopy) {
      setChallanDataCopy(location.state.challanDataCopy);

      // ✅ IMPORTANT: Clear router state after reading once
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.state]);

  // console.log("challanData", challanData);
  // console.log("challanDataCopy", challanDataCopy);

  // console.log("billResponse", billResponse);

  useEffect(() => {
    if (challanData || challanDataCopy) {
      scrollToTop();
      setIsEdit(false);
      setIsCreate(true);
    }
    // setSelectedCustomer(null)
  }, [challanData, challanDataCopy]);

  useEffect(() => {
    if (selectedCustomer) {
      scrollToTop();
      setIsEdit(false);
      setIsCreate(true);
    }
    // setSelectedCustomer(null)
  }, [selectedCustomer]);

  const [challanCopy, setChallanCopy] = useState(null);

  const handleCopyChallan = (data) => {
    scrollToTop();
    setIsEdit(false);
    setIsCreate(true);
    setChallanCopy(data);
  };

  const [printData, setPrintData] = useState(null);
const [openPrintChild, setOpenPrintChild] = useState(false);

  const handlePrintPopup = (data) => {
    Swal.fire({
      title: "Print Challan?",
      text: "Do you want to continue printing this challan?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "#1976d2",
    }).then((result) => {
      if (result.isConfirmed) {
        setPrintData(data); // ✅ store data
        setOpenPrintChild(true); // ✅ open child
      }
    });
  };

  //#endregion

  return (
    <>
      <Container>
        <CardHeadMenu
          prefix={"Na"}
          suffix={"Na"}
          title={"Challan"}
          handlePopup={handlePopup}
          isEdit={isEdit}
          create={isCreate}
          showCreate={Boolean(
            is_super || is_admin || permissions?.includes(62),
          )}
        />

        {isCreate && (
          <ChallanCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            clear={clear}
            setIsChanged={setIsChanged}
            isChanged={isChanged}
            isCreate={isCreate} // State passed as a prop
            setIsCreate={setIsCreate} // Function passed as a prop
            selectedCustomerr={selectedCustomer}
            productData={productData}
            setProductData={setProductData}
            setSelectedCustomerr={setSelectedCustomer}
            challanData={challanData}
            setChallanData={setChallanData}
            billResponse={billResponse}
            setBillResponse={setBillResponse}
            challanDataCopy={challanDataCopy}
            setChallanDataCopy={setChallanDataCopy}
            challanCopy={challanCopy}
            setChallanCopy={setChallanCopy}
            printpopup={handlePrintPopup}
          />
        )}
        <ChallanTable
          handleEditData={handleEditData}
          isChanged={isChanged}
          handleCopyChallan={handleCopyChallan}
          data={printData}
          onClose={() => setOpenPrintChild(false)}
        />
      </Container>
    </>
  );
};
export default ChallanPage;
